/**
 * FindAccountResultPresenter
 * --
 */
import React from 'react';
import { Content, Row, Col, Title } from 'components';
import { Button } from 'antd';

const FindAccountResultPresenter = ({
  navigate,
  data,
  screenSize,
  onNavigate,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 40 : 32,
      lineHeight: '120%',
      fontWeight: 700,
      color: 'var(--black-color)',
    },

    text: {
      marginTop: screenSize >= 768 ? 20 : 12,
      fontSize: screenSize >= 768 ? 18 : 12,
      fontWeight: 400,
      lineHeight: '180%',
      color: 'var(--black-color)',
      textAlign: 'center',
    },

    button: {
      height: 58,
      fontSize: 16,
      fontWeight: 700,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    resultBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderTop: '1px solid',
      borderBottom: '1px solid',
      borderColor: 'var(--black-color)',
      marginTop: screenSize >= 768 ? 80 : 40,
      marginBottom: screenSize >= 768 ? 80 : 40,
    },
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={1820} padding={'100px 0px'}>
      <Row gutter={16}>
        <Col x={1} md={8}></Col>
        <Col x={22} md={8}>
          <Title align={'center'} style={{ ...styles.title }}>
            아이디 확인
          </Title>

          <p style={{ ...styles.text }}>
            입력하신 정보와 일치하는 아이디는 다음과 같습니다
          </p>

          <Content
            maxWidth={'100%'}
            padding={screenSize >= 768 ? '80px 0px' : '60px 0px'}
            style={{
              ...styles.resultBox,
            }}
          >
            <Title align={'center'} style={{ ...styles.title }}>
              {data.user_account}
            </Title>
          </Content>

          <Row gutter={16}>
            {data.social_type === 'GENERAL' ? (
              <Col x={12}>
                <Button
                  style={{ ...styles.button }}
                  onClick={() => onNavigate(`password`)}
                >
                  비밀번호 찾기
                </Button>
              </Col>
            ) : null}

            <Col x={data.social_type === 'GENERAL' ? 12 : 24}>
              <Button
                type="primary"
                style={{ ...styles.button }}
                onClick={() => onNavigate('signin')}
              >
                로그인
              </Button>
            </Col>
          </Row>
        </Col>
        <Col x={1} md={8}></Col>
      </Row>
    </Content>
  );
};

export default FindAccountResultPresenter;
